import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Hero from '../../components/Hero/Hero';
import Stats from '../../components/Stats/Stats';
import About from '../../components/About/About';
import WhyUpgrade from '../../components/WhyUpgrade/WhyUpgrade';
import Process from '../../components/Process/Process';
import Brands from '../../components/Brands/Brands';
import Categories from '../../components/Categories/Categories';
import InstagramProjects from '../../components/InstagramProjects/InstagramProjects';
import Testimonials from '../../components/Testimonials/Testimonials';
import FAQ from '../../components/FAQ/FAQ';
import Footer from '../../components/Footer/Footer';

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a scrollTo state from navigation
    const state = location.state as { scrollTo?: string } | null;
    const scrollToSection = state?.scrollTo;
    
    if (scrollToSection) {
      setTimeout(() => {
        const element = document.getElementById(scrollToSection);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      // Clear the state after scrolling
      window.history.replaceState({}, document.title);
    } 
    // Check if there's a hash in the URL
    else if (location.hash) {
      const sectionId = location.hash.substring(1); // Remove the #
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Header />
      <Hero />
      <Stats />
      <About />
      <WhyUpgrade />
      <Process />
      <Brands />
      <Categories />
      <InstagramProjects />
      <Testimonials />
      <FAQ />
      <Footer />
    </>
  );
};

export default Home;
